<template>
  <v-data-table
    :headers="headers"
    :items="files"
    class="elevation-0"
    locale="ja-jp"
    hide-default-footer
    item-key="item_no"
    dense
    v-if="display && files.length > 0"
  >
  </v-data-table>
</template>
<script>
export default {
  name: "FileList",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    display: {
      type: Boolean
    }
  },
  computed: {
    headers() {
      return [
        {
          text: "No.",
          value: "item_no",
          sortable: false
        },
        {
          text: "ファイル",
          value: "name",
          sortable: false
        },
        {
          text: "備考",
          value: "title",
          sortable: false
        }
      ];
    },
    files: function() {
      if (this.items.length > 0) {
        const items = this.items
          .filter(item => item.file && item.file instanceof File)
          .map((item, index) => ({
            item_no: index + 1,
            name: item.file.name,
            title: item.remarks
          }));
        return items;
      }
      return [];
    }
  }
};
</script>
